import Vue from "vue";

export default {
  getBranches({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && {
          search_query: state.searchQuery,
        }),
        ...(state.filterValue != "" && { filter: state.filterValue }),
      };

      Vue.$http
        .get("/organization/branches", { params })
        .then(response => {
          commit("branches", response.data.results);
          commit("branchTotal", response.data.total);
          commit("tableLoader", false);

          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  getAllBranches() {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/branches")
        .then(response => {
          // backend now always wraps the branch list as { results, total }
          resolve({
            ...response,
            data: response.data.results || response.data,
          });
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  createBranch({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/organization/branches", params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
          commit("tableLoader", false);
        });
    });
  },

  updateBranch({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/organization/branches/${params.id}`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
          commit("tableLoader", false);
        });
    });
  },

  deleteBranch({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/organization/branches/${id}`)
        .then(response => {
          resolve(response);
          commit("tableLoader", false);
        })
        .catch(error => {
          reject(error);
          commit("tableLoader", false);
        });
    });
  },

  handleSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getBranches");
  },

  handleCurrentChange({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getBranches");
  },

  getBranch({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/organization/branches/${id}`)
        .then(response => {
          commit("currentViewedBranch", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
          commit("tableLoader", false);
        });
    });
  },
  getDepartmentsByBranch({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/organization/branches/${id}/departments`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
          commit("tableLoader", false);
        });
    });
  },
  fetchBranchTypes({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/branch-types")
        .then(response => {
          commit("branchTypes", response.data);
          resolve(response.data);
          commit("tableLoader", false);
        })
        .catch(error => {
          reject(error);
          commit("tableLoader", false);
        });
    });
  },
};
